import React, { ReactElement } from 'react';
import { ContainerLayout } from 'layouts';
import { TranslationContext } from '@ds/react-utils';
import { WarningIcon } from 'components/shared';

const GeneralErrorPage = (): ReactElement => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayout>
            <ContainerLayout.Header>
                <WarningIcon dataQa='verify-general-error-warning-icon' />
                <ContainerLayout.Header.Title titleDataQa="verify-general-error-title" title={translate('We couldn’t connect to this service')} />
            </ContainerLayout.Header>

            <ContainerLayout.InnerContent dataQa="verify-general-error-content">
                <p>{translate('We can’t recover your session at this time.')}</p>
            </ContainerLayout.InnerContent>
        </ContainerLayout>
    );
};

export default GeneralErrorPage;
